import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from "@mui/material";

interface PromptDialogProps {
  open: boolean;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
  title?: string;
  confirmText?: string;
  cancelText?: string;
  helperText?: string;
}

const PromptDialog: React.FC<PromptDialogProps> = ({
  open,
  label,
  value,
  onChange,
  onCancel,
  onConfirm,
  title = "Enter Value",
  confirmText = "OK",
  cancelText = "Cancel",
  helperText,
}) => {
  const [touched, setTouched] = React.useState(false);
  const isValid = value.trim().length > 0;

  React.useEffect(() => {
    if (!open) setTouched(false);
  }, [open]);

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <TextField
            autoFocus
            fullWidth
            label={label}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onBlur={() => setTouched(true)}
            error={touched && !isValid}
            helperText={
              !isValid && touched
                ? helperText || `${label} is required.`
                : helperText || ""
            }
            variant="outlined"
            size="medium"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{cancelText}</Button>
        <Button onClick={onConfirm} variant="contained" disabled={!isValid}>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PromptDialog;
